module.exports = __webpack_public_path__ + "img/next.d74fc102.svg";